module.exports = __webpack_public_path__ + "static/img/bg_7.cdb8470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_7.png
// module id = 5oX5
// module chunks = 1